export const planOffers = [
  {
    plan: 'personalLifetime',
    price: { amount: '19.90', currency: 'USD' },
    maxBindings: 1,
    billingModel: 'perpetual',
    updatesIncluded: true,
    available: true,
  },
  {
    plan: 'familyLifetime',
    price: { amount: '39.90', currency: 'USD' },
    maxBindings: 3,
    billingModel: 'perpetual',
    updatesIncluded: true,
    available: true,
  },
] as const;

export const upgradeOffer = {
  from: 'personalLifetime',
  to: 'familyLifetime',
  price: { amount: '20.00', currency: 'USD' },
  billingModel: 'perpetual',
  updatesIncluded: true,
  available: true,
} as const;
